import DynamicService from '@/service/DynamicService';
import AllTypeSchema from '../schemas/AllTypeSchema';

const formatResponse = () => {
};

const AllTypesService = DynamicService('all_types', AllTypeSchema, { formatResponse });

export default AllTypesService;
